import axios from 'axios';
import { showMessage } from 'app/store/actions/fuse';

import { API_BASE_URL } from '@config';

export const CLEAR_ERROR = 'CLEAR_ERROR';
export const clearError = () => ({
	type: CLEAR_ERROR
});

export const SET_ACTIONS_ERROR = 'SET_ACTIONS_ERROR';
export const setActionsError = err => ({
	type: SET_ACTIONS_ERROR,
	payload: err
});

export const CLEAR_SETTINGS_REDUCER = 'CLEAR_SETTINGS_REDUCER';
export const clearSettingsReducer = () => ({
	type: CLEAR_SETTINGS_REDUCER
});


export const submitCleanDB = days => dispatch => {
	const request = axios.post(`${API_BASE_URL}/api/clusters/cleandb`, days);
	return request
		.then(() => dispatch(showMessage({ message: 'Clean DB.' })))
		.catch(err =>
			dispatch(
				setActionsError({
					...err.data,
					type: 'modal',
					message: `Error ${err?.data?.status}!, WEP-API not ready yet`
				})
			)
		);
};

// ============================================================================
// Provider Visibility Actions (003-in-the-ui)
// ============================================================================

export const GET_PROVIDER_VISIBILITY_REQUEST = 'GET_PROVIDER_VISIBILITY_REQUEST';
export const GET_PROVIDER_VISIBILITY_SUCCESS = 'GET_PROVIDER_VISIBILITY_SUCCESS';
export const GET_PROVIDER_VISIBILITY_FAILURE = 'GET_PROVIDER_VISIBILITY_FAILURE';

export const UPDATE_PROVIDER_VISIBILITY_REQUEST = 'UPDATE_PROVIDER_VISIBILITY_REQUEST';
export const UPDATE_PROVIDER_VISIBILITY_SUCCESS = 'UPDATE_PROVIDER_VISIBILITY_SUCCESS';
export const UPDATE_PROVIDER_VISIBILITY_FAILURE = 'UPDATE_PROVIDER_VISIBILITY_FAILURE';

export const CHECK_PROVIDER_VISIBILITY_REQUEST = 'CHECK_PROVIDER_VISIBILITY_REQUEST';
export const CHECK_PROVIDER_VISIBILITY_SUCCESS = 'CHECK_PROVIDER_VISIBILITY_SUCCESS';
export const CHECK_PROVIDER_VISIBILITY_FAILURE = 'CHECK_PROVIDER_VISIBILITY_FAILURE';

/**
 * Get provider visibility settings
 */
export const getProviderVisibility = () => dispatch => {
	dispatch({ type: GET_PROVIDER_VISIBILITY_REQUEST });

	const request = axios.get(`${API_BASE_URL}/api/settings/provider-visibility`);
	
	return request
		.then(response => {
			dispatch({
				type: GET_PROVIDER_VISIBILITY_SUCCESS,
				payload: response.data
			});
			return response.data;
		})
		.catch(err => {
			const errorMessage = err?.response?.data?.error || 'Failed to fetch provider visibility settings';
			dispatch({
				type: GET_PROVIDER_VISIBILITY_FAILURE,
				payload: errorMessage
			});
			dispatch(showMessage({ message: errorMessage, variant: 'error' }));
			throw err;
		});
};

/**
 * Update provider visibility settings (Admin only)
 */
export const updateProviderVisibility = (providerVisibility) => dispatch => {
	dispatch({ type: UPDATE_PROVIDER_VISIBILITY_REQUEST });

	const request = axios.put(`${API_BASE_URL}/api/settings/provider-visibility`, {
		providerVisibility
	});
	
	return request
		.then(response => {
			dispatch({
				type: UPDATE_PROVIDER_VISIBILITY_SUCCESS,
				payload: response.data
			});
			dispatch(showMessage({ 
				message: 'Provider visibility settings updated successfully', 
				variant: 'success' 
			}));
			return response.data;
		})
		.catch(err => {
			const errorMessage = err?.response?.data?.error || 'Failed to update provider visibility settings';
			dispatch({
				type: UPDATE_PROVIDER_VISIBILITY_FAILURE,
				payload: errorMessage
			});
			dispatch(showMessage({ message: errorMessage, variant: 'error' }));
			throw err;
		});
};

/**
 * Check if a specific provider is visible
 */
export const checkProviderVisibility = (provider) => dispatch => {
	dispatch({ type: CHECK_PROVIDER_VISIBILITY_REQUEST });

	const request = axios.post(`${API_BASE_URL}/api/settings/provider-visibility/check`, {
		provider
	});
	
	return request
		.then(response => {
			dispatch({
				type: CHECK_PROVIDER_VISIBILITY_SUCCESS,
				payload: response.data
			});
			return response.data;
		})
		.catch(err => {
			const errorMessage = err?.response?.data?.error || 'Failed to check provider visibility';
			dispatch({
				type: CHECK_PROVIDER_VISIBILITY_FAILURE,
				payload: errorMessage
			});
			dispatch(showMessage({ message: errorMessage, variant: 'error' }));
			throw err;
		});
};
